(function () {
    "use strict";

    angular.module("app").component("errorPage", {
        templateUrl: "@/errors/error-page.template.html",
        transclude: {
            "title": "errorTitle",
            "description": "errorDescription",
        },
        bindings: { "homePage": "@", },
        controller: errorPageController,
    });

    errorPageController.$inject = ["loadingIndicatorService",];
    function errorPageController(loadingIndicatorService) {
        loadingIndicatorService.SetLoadingState(false);
    }
})();
